import { ModalService } from '@app/plugins/iview-modal-modify/service';
import { WebhookService } from '@autocaller_v2/services/WebhookService';
import ItemForm from '@autocaller_v2/components/modal-webhook-create-edit-form';
import i18n from '@app/plugins/i18n';

class WebhookModalService extends ModalService {
  constructor() {
    super(WebhookService);
  }

  remove(id, item) {
    return this.$removeItem(id, item, {
      content: i18n.t('autocaller_v2.webhook.modal.remove.content', {
        type: `<strong>${item.type}</strong>`
      })
    });
  }

  edit(id, item) {
    return this.$open({
      title: i18n.t('autocaller_v2.webhook.modal.edit'),
      width: this.size.default,
      loading: true,
      render: h =>
        h(ItemForm, {
          props: {
            id: id,
            item: item
          },

          on: {
            success: data => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }

  create() {
    return this.$open({
      title: i18n.t('autocaller_v2.webhook.modal.create'),
      width: this.size.default,
      loading: true,
      render: h =>
        h(ItemForm, {
          on: {
            success: data => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }
}

const instance = new WebhookModalService();
export { instance as WebhookModalService };
